import { IExportColumnModel } from "../../../shared/models";

export const AccountColumnList: IExportColumnModel[] = [
]